<div style="display: flex">
    <p-dialog
        header="Manage Address"
        [(visible)]="addAddress"
        [modal]="true"
        [maximizable]="false"
        [closable]="false"
        [closeOnEscape]="false"
        [style]="{ 'max-width': '50%', 'max-height': '75%' }"
    >
        <div class="mt-4">
            <p-message severity="info" text="If address already exists in QuickBooks customer/job record, run a sync list to bring in the new address."></p-message>
        </div>

        <form
            [formGroup]="addAddressFormGroup"
            #addAddressForm="ngForm"
            id="eventForm"
            class="grid"
        >
            <!-- <label style="font-size: 11px">Start Date</label>
            <div class="mb-1">
                <p-calendar appendTo="body" formControlName="startDate">
                </p-calendar>
            </div> -->
            <p-floatLabel variant="on" class="mb-3 mt-4 w-full">
                <p-select
                    styleClass="w-full"
                    [options]="addressTypes"
                    [filter]="true"
                    appendTo="body"
                    [autoDisplayFirst]="false"
                    formControlName="AddressType"
                >
                </p-select>
                <label>Type</label>
            </p-floatLabel>
            <p-floatLabel variant="on" class="mb-3 w-full">
                <input
                    formControlName="AddressName"
                    class="ef-dialog-control w-full"
                    type="text"
                    pInputText
                    required
                />
                <label for="float-dd">Name</label>
            </p-floatLabel>
            <p-floatLabel variant="on" class="mb-3 w-full">
                <input
                    formControlName="Addr1"
                    class="ef-dialog-control w-full"
                    type="text"
                    pInputText
                    required
                />
                <label for="float-dd">Line 1</label>
            </p-floatLabel>
            <p-floatLabel variant="on" class="mb-3 w-full">
                <input
                    formControlName="Addr2"
                    class="ef-dialog-control w-full"
                    type="text"
                    pInputText
                    required
                />
                <label for="float-dd">Line 2</label>
            </p-floatLabel>
            <p-floatLabel variant="on" class="mb-3 w-full">
                <input
                    formControlName="Addr3"
                    class="ef-dialog-control w-full"
                    type="text"
                    pInputText
                    required
                />
                <label for="float-dd">Line 3</label>
            </p-floatLabel>
            <p-floatLabel variant="on" class="mb-3 w-full">
                <input
                    formControlName="Addr4"
                    class="ef-dialog-control w-full"
                    type="text"
                    pInputText
                    required
                />
                <label for="float-dd">Line 4</label>
            </p-floatLabel>
            <div class="w-full grid mb-3">
                <div class="col-4">
                    <p-floatLabel variant="on">
                        <input
                            formControlName="City"
                            class="ef-dialog-control w-full"
                            type="text"
                            pInputText
                            required
                        />
                        <label for="float-dd">City</label>
                    </p-floatLabel>
                </div>
                <div class="col-4 h-full">
                    <p-floatLabel variant="on">
                        <p-select
                            [style]="{ 'min-height': '2.5rem' }"
                            styleClass="w-full"
                            [options]="states"
                            [filter]="true"
                            appendTo="body"
                            [autoDisplayFirst]="false"
                            formControlName="State"
                        >
                        </p-select>
                        <label for="float-dd">State</label>
                    </p-floatLabel>
                </div>
                <div class="col-4">
                    <p-floatLabel variant="on">
                        <input
                            formControlName="PostalCode"
                            class="ef-dialog-control w-full"
                            type="text"
                            pInputText
                            required
                        />
                        <label for="float-dd">Postal Code</label>
                    </p-floatLabel>
                </div>
            </div>
            <p-floatLabel variant="on" class="mb-3 w-full">
                <input
                    pInputText
                    class="ef-dialog-control w-full"
                    type="text"
                    formControlName="Contact"
                />
                <label for="float-dd">Contact</label>
            </p-floatLabel>
            <p-floatLabel variant="on" class="mb-3 w-full">
                <input
                    pInputText
                    class="ef-dialog-control w-full"
                    type="text"
                    formControlName="AltContact"
                />
                <label for="float-dd">Alternate Contact</label>
            </p-floatLabel>
        </form>
        <ng-template #footer>
            <button
                type="button"
                pButton
                class="p-button-text p-button-success"
                icon="pi pi-check"
                (click)="Save.next(this.addAddressFormGroup.value)"
                label="Save"
            ></button>
            <button
                type="button"
                pButton
                class="p-button-text p-button-danger"
                (click)="this.Cancel.next()"
                icon="pi pi-times"
                label="Cancel"
            ></button>
        </ng-template>
    </p-dialog>
</div>
